import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import ColorPickerListItem from '../../../../../../list-items/ColorPickerListItem';

const ParticlesColorListItem = (props) => {
    const { particleColor, customEmoji, customImageUrl, index, updateParticleElement } = props;

    const onColorChange = (color) => updateParticleElement(index, { 
        color: color.hex.replace('#', '0x') 
    });

    const isDefaultShape = !customEmoji && !customImageUrl;

    if (!isDefaultShape) {
        return null;
    }

    return (
        <ColorPickerListItem
            text='Tint'
            color={particleColor.replace('0x', '#')}
            onChange={onColorChange}
            disableAlpha={true}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const particleElement = state.createPreview.present.videoSettings.elements.particles.items[ownProps.index];
    return { 
        particleColor: particleElement.color,
        customEmoji: particleElement.customEmoji,
        customImageUrl: particleElement.customImageUrl
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateParticleElement = (index, properties) => dispatch(createActions.updateParticleElement(index, properties));
    return { updateParticleElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(ParticlesColorListItem);